import React from 'react';
import {Field, ErrorMessage} from 'formik';

import styles from 'legacy_css_modules/Input.module.css';

export const Input = ({children, className, disabled, inputClass, isHidden, isRequired, itemRow,highlighted,noErrorPlaceholder,...props}) => {
    const classNames = `${className} ${isHidden ? styles.hidden : null}`;
    
    return (
        <label className={classNames}>{children}
            {isRequired && !disabled && <span title="Povinné pole" className={styles.asterisk}>*</span>}
            <div
                style={{
                    border: highlighted === 6 ? '' : highlighted ? '1px solid var(--red)' : '1px solid white',
                }}
            >
                <Field className={inputClass} disabled={disabled} {...props}/>
            </div>
            {!noErrorPlaceholder===true && 
                <div className={styles.errorPlaceholder}>
                <ErrorMessage name={props.name}>
                    {data =>
                        Array.isArray(data)
                            ? data.map((error, index) => <p key={index} className={styles.error}>{error}</p>)
                            : <p className={styles.error}>{data}</p>
                    }
                </ErrorMessage>
                </div>}
        </label>
    )
};